<div class="report-an-error-dialog">
  <div class="report-an-error-dialog-header">
    <h2 class="report-an-error-dialog-header-title">Signaler une erreur</h2>
    <p class="report-an-error-dialog-header-subtitle">
      {{ data.litigationTitle }}
    </p>
  </div>

  <form
    [formGroup]="errorForm"
    (ngSubmit)="save()"
    class="report-an-error-dialog-form"
  >
    <div class="report-an-error-dialog-form-content">
      <div class="report-an-error-dialog-form-group">
        <label for="subject" class="report-an-error-dialog-form-label"
          >Objet</label
        >
        <input
          id="subject"
          type="text"
          formControlName="subject"
          class="report-an-error-dialog-form-input"
          [class.report-an-error-dialog-form-input--invalid]="
            errorForm.get('subject')?.invalid &&
            errorForm.get('subject')?.touched
          "
        />

        <div
          class="report-an-error-dialog-form-error"
          *ngIf="
            errorForm.get('subject')?.hasError('required') &&
            errorForm.get('subject')?.touched
          "
        >
          L'objet est obligatoire
        </div>
      </div>

      <div class="report-an-error-dialog-form-group">
        <label for="message" class="report-an-error-dialog-form-label"
          >Message</label
        >
        <textarea
          id="message"
          formControlName="message"
          class="report-an-error-dialog-form-textarea"
          rows="12"
          placeholder="Veuillez s'il vous plait décrire la nature du problème que vous rencontrez"
          [class.report-an-error-dialog-form-textarea--invalid]="
            errorForm.get('message')?.invalid &&
            errorForm.get('message')?.touched
          "
        ></textarea>

        <div
          class="report-an-error-dialog-form-error"
          *ngIf="
            errorForm.get('message')?.hasError('required') &&
            errorForm.get('message')?.touched
          "
        >
          Le message est obligatoire
        </div>
      </div>
    </div>

    <div class="report-an-error-dialog-actions">
      <button
        class="report-an-error-dialog-actions-button report-an-error-dialog-actions-button--cancel"
        type="button"
        (click)="close()"
      >
        Annuler
      </button>
      <button
        class="report-an-error-dialog-actions-button report-an-error-dialog-actions-button--submit"
        type="submit"
        [disabled]="!errorForm.valid"
      >
        Valider
      </button>
    </div>
  </form>
</div>
